 
import { ProFormaModelIds } from 'constants/proForma';

export enum ColumnKeys {
    START_DATE = 'startDate',
    ANNUAL_GROWTH = 'annualGrowth',
    PERCENT_OF_TOTAL_RENT = 'percentOfTotalRent',
    PRICE_PER_SF = 'pricePerSf',
    PRICE_PER_SF_PER_YEAR = 'pricePerSfPerYear',
    PRICE_PER_UNIT = 'pricePerUnit',
    PRICE_PER_BED = 'pricePerBed',
    BEDS = 'beds',
    VALUE_PER_RACK_PER_YEAR = 'valuePerRackPerYear',
    VALUE_PER_KW_PER_YEAR = 'valuePerKwPerYear',
}

export const COLUMN_KEYS_BY_MODEL_ID: Record<string, ColumnKeys[]> = {
    [ProFormaModelIds.APARTMENT]: [
        ColumnKeys.ANNUAL_GROWTH,
        ColumnKeys.PERCENT_OF_TOTAL_RENT,
        ColumnKeys.PRICE_PER_SF,
        ColumnKeys.PRICE_PER_UNIT,
    ],
    [ProFormaModelIds.APARTMENT_WITH_RETAIL]: [
        ColumnKeys.ANNUAL_GROWTH,
        ColumnKeys.PERCENT_OF_TOTAL_RENT,
        ColumnKeys.PRICE_PER_SF,
        ColumnKeys.PRICE_PER_UNIT,
    ],
    [ProFormaModelIds.STUDENT_HOUSING]: [
        ColumnKeys.ANNUAL_GROWTH,
        ColumnKeys.PRICE_PER_SF,
        ColumnKeys.PRICE_PER_BED,
        ColumnKeys.BEDS,
    ],
    [ProFormaModelIds.RETAIL]: [
        ColumnKeys.START_DATE,
        ColumnKeys.ANNUAL_GROWTH,
        ColumnKeys.PERCENT_OF_TOTAL_RENT,
        ColumnKeys.PRICE_PER_SF_PER_YEAR,
    ],
    [ProFormaModelIds.OFFICE]: [
        ColumnKeys.START_DATE,
        ColumnKeys.ANNUAL_GROWTH,
        ColumnKeys.PERCENT_OF_TOTAL_RENT,
        ColumnKeys.PRICE_PER_SF_PER_YEAR,
    ],
    [ProFormaModelIds.INDUSTRIAL]: [
        ColumnKeys.START_DATE,
        ColumnKeys.ANNUAL_GROWTH,
        ColumnKeys.PERCENT_OF_TOTAL_RENT,
        ColumnKeys.PRICE_PER_SF_PER_YEAR,
    ],
    [ProFormaModelIds.DATA_CENTER]: [
        ColumnKeys.START_DATE,
        ColumnKeys.ANNUAL_GROWTH,
        ColumnKeys.PERCENT_OF_TOTAL_RENT,
        ColumnKeys.VALUE_PER_RACK_PER_YEAR,
        ColumnKeys.VALUE_PER_KW_PER_YEAR,
    ],
};
